

/**
 * @name EditAssociationController
 * @description Function to remove operators from a shop
 * @param {library} $uibModalInstance UI Bootstrap modal service
 * @param {service} Association The association service
 * @param {object} association Resolved association from the comonent controller
 * @param {service} Session The Session service
 * @param {service} ArtistNotificationPrefs The ArtistNotificationPrefs service
 * @param {service} OperatorNotificationPrefs The OperatorNotificationPrefs service
 */
function EditAssociationController(
  $uibModalInstance,
  Association,
  association,
  Session,
  ArtistNotificationPrefs,
  OperatorNotificationPrefs
) {
  let vm = this;
  vm.association = association;
  vm.update = update;
  vm.session = Session;

  get(vm.association);

  /**
   * @name get
   * @description Function to get notification prefs for this association
   * @param {object} association The association related to the preferences
   */
  function get(association) {
    if (association.type === 'artist' &&
    association.artistNotificationPreference) {
      ArtistNotificationPrefs.get(association.artistNotificationPreference)
      .then(function(notprefs) {
        vm.artistNotPrefs = notprefs;
      });
    } else if (association.type === 'operator' &&
    association.operatorNotificationPreference) {
      OperatorNotificationPrefs.get(association.operatorNotificationPreference)
      .then(function(notprefs) {
        vm.operatorNotPrefs = notprefs;
      });
    }
  }

  /**
   * @name update
   * @description Function to update these notification preferences
   */
  function update() {
    if (vm.artistNotPrefs) {
      ArtistNotificationPrefs.update(
        vm.association.artistNotificationPreference,
        vm.artistNotPrefs
      )
      .then(function(notprefs) {
        $uibModalInstance.close(notprefs);
      });
    } else if (vm.operatorNotPrefs) {
      OperatorNotificationPrefs.update(
        vm.association.operatorNotificationPreference,
        vm.operatorNotPrefs)
      .then(function(notprefs) {
        $uibModalInstance.close(notprefs);
      });
    }
  }

  vm.cancel = function() {
    $uibModalInstance.dismiss();
  };
}

angular
.module('inkfinder')
.controller('EditAssociationController', EditAssociationController);



// WEBPACK FOOTER //
// ./components/collector/associations/list/edit-association-modal.controller.js